export const isDev = () => process.env.NODE_ENV === 'development';
export const isProd = () => process.env.NODE_ENV === 'production';
export const isTest = () => process.env.NODE_ENV === 'test';
export const isOnServer = () => !!process.env.SERVER_SIDE;

export const getEnv = (key, def) => {
  if(isProd()) {
    // `def` has to apply in production too. This branch used to ignore it, so
    // About.jsx's getEnv('RELEASE', 'dev') could not fall back on the live site
    // no matter what the value was.
    return global.env_vars[key] || def;
  }
  const value = (process.env[key] || process.env[`REACT_APP_${key}`]) || def;
  return value;
};

